// removed by extract-text-webpack-plugin
module.exports = {"label":"_1V8HS","right":"_3OobU","level1":"o2-vG","switch":"_268nJ","switchInput":"_2Jknx","switchLabel":"_2PL8X","switchI":"_24DTI","checkedIcon":"_1TyCQ","uncheckedIcon":"Z0Gdj"};


//////////////////
// WEBPACK FOOTER
// ./app/components/input-toggle/input-toggle.scss
// module id = 1748
// module chunks = 0